import React from 'react';
import QAHistory from './QAHistory';
import {
  getQAHistory,
  getQAStatistics,
  submitFeedback,
  markQAAnswer,
} from '../services/managerService';

function ManagerQAHistory() {
  return (
    <QAHistory
      agentName="Manager Agent"
      fetchHistory={getQAHistory}
      fetchStatistics={getQAStatistics}
      submitFeedback={(qaId, feedback) => submitFeedback(qaId, 4, feedback)}
      markAnswer={(qaId, isCorrect) => markQAAnswer(qaId, isCorrect, true)}
    />
  );
}

export default ManagerQAHistory;
